// Test Out Exercises by Phase
// Machine Option = true means this is the machine variant
// Exercises are filtered by phase and machine preference

export const testOutExercises = [
  // ========== PHASE 1 ==========
  // Non-Machine
  {
    id: 'LyCJ7PWkQj6pWWhVfaK56Q',
    phase: 1,
    exercise: '1-Leg Squat',
    displayName: 'Quad Test',
    video: 'https://youtu.be/MjaaFJOgNSA',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣⁣ Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'odE0eFLpRoCOOX3LxI3rVQ',
    phase: 1,
    exercise: '1-Leg Bridge',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/dpnGGEniQrg',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣ Note that the working leg should only be slightly bent (~30°). Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight in the hip crease of your working leg that's heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  // Machine
  {
    id: 'nWN7U0j9RweOZuyzpXDaYQ',
    phase: 1,
    exercise: 'Machine Leg Extension',
    displayName: 'Quad Test',
    video: 'https://youtu.be/X6dG2K2tTFM',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'OV88pAXHS1uu5lqdLx1meQ',
    phase: 1,
    exercise: 'Machine Leg Curl',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/GnKPGRg430A',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },

  // ========== PHASE 2 ==========
  // Non-Machine
  {
    id: 'p.iLhenuQuS0CvYfO.K8Rw',
    phase: 2,
    exercise: '1-Leg Squat',
    displayName: 'Quad Test',
    video: 'https://youtu.be/MjaaFJOgNSA',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣⁣ Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'fX4yOFQFRC-YCjf9qK1Aow',
    phase: 2,
    exercise: '1-Leg Bridge',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/dpnGGEniQrg',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣ Note that the working leg should only be slightly bent (~30°). Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight in the hip crease of your working leg that's heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'zVaKaq4AR6iAS-CMKgbRtw',
    phase: 2,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: 'a-EpEgEl.TfS1F9KU30bW4g',
    phase: 2,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/uN8aQcDxDvw',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 3,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true, // Special flag for binary yes/no scoring
  },
  // Machine
  {
    id: 'wA4JffCQTuKMdyzYbd0GWA',
    phase: 2,
    exercise: 'Machine Leg Extension',
    displayName: 'Quad Test',
    video: 'https://youtu.be/X6dG2K2tTFM',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'jCVX.yPySgWqIuCk0Jxvqg',
    phase: 2,
    exercise: 'Machine Leg Curl',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/GnKPGRg430A',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'qy0-KWLNRQOrvV32fHj7Gw',
    phase: 2,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: 'c-4YLtJsRXaBiOAEWgnChg',
    phase: 2,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/uN8aQcDxDvw',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 3,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true,
  },

  // ========== PHASE 3 ==========
  // Non-Machine
  {
    id: 'oDizOTffTTe9FHiJbw56Dw',
    phase: 3,
    exercise: '1-Leg Squat',
    displayName: 'Quad Test',
    video: 'https://youtu.be/MjaaFJOgNSA',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣⁣ Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'h2BjyL9zRi-lI3I5yib.lw',
    phase: 3,
    exercise: '1-Leg Bridge',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/dpnGGEniQrg',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣ Note that the working leg should only be slightly bent (~30°). Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight in the hip crease of your working leg that's heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'ChvlmybkQVeXJpVGCGF.XA',
    phase: 3,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: 'Y7ZS-.YmR8SCYM2YANkKyg',
    phase: 3,
    exercise: 'Rotational Hop',
    displayName: 'Rotational Hop',
    video: 'https://youtu.be/g0zWC-mml98',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 3,
    metronome: false,
    scoringKey: 'rotationalHop',
  },
  {
    id: 'h5i34yW9RPKjkRJQ-LrYLA',
    phase: 3,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/6hKhs-8WfE8',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 4,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true,
  },
  // Machine
  {
    id: 'aAQE8QXiRmukDriLWuSI4w',
    phase: 3,
    exercise: 'Machine Leg Extension',
    displayName: 'Quad Test',
    video: 'https://youtu.be/X6dG2K2tTFM',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: 'pqzNFNybS6OOb.awxvwk7w',
    phase: 3,
    exercise: 'Machine Leg Curl',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/GnKPGRg430A',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'KrgYj2XDSY2c0Aymw.MPVg',
    phase: 3,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: 'v3hjOqBPRWek8wnsIEsMfg',
    phase: 3,
    exercise: 'Rotational Hop',
    displayName: 'Rotational Hop',
    video: 'https://youtu.be/g0zWC-mml98',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 3,
    metronome: false,
    scoringKey: 'rotationalHop',
  },
  {
    id: 'a.J9HwmkxQqyHGinTMuZuKA',
    phase: 3,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/6hKhs-8WfE8',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 4,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true,
  },

  // ========== PHASE 4 ==========
  // Non-Machine
  {
    id: 'tIR18L0rT9aEdr41ftguTA',
    phase: 4,
    exercise: '1-Leg Squat',
    displayName: 'Quad Test',
    video: 'https://youtu.be/MjaaFJOgNSA',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣ Only document the highest level you perform.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: '6elaYzxKQoS8vS1zcsfvfA',
    phase: 4,
    exercise: '1-Leg Bridge',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/dpnGGEniQrg',
    description: `The goal of this test is to do at least 8 but no more than 12 reps on each leg. Choose your weight and level accordingly; you do not need to start at Level 1.⁣ Note that the working leg should only be slightly bent (~30°). Only document the highest level you perform.

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟏, use bodyweight and a 1-1-1-1 tempo. If you're able to get to 12 reps on either leg without reaching failure at Level 1, repeat the test at Level 2.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟐, use the same 1-1-1-1 tempo while holding a weight in the hip crease of your working leg that's heavy enough to limit you to 12 reps (if available). If you're able to get to 12 reps on either leg without reaching failure at Level 2, repeat the test at Level 3.⁣

𝐅𝐨𝐫 𝐋𝐞𝐯𝐞𝐥 𝟑, use a 3-1-1-1 tempo while holding the weight. If you're able to get to 12 reps on either leg without reaching failure at Level 3, repeat the test with a heavier weight.⁣

Click play on the audio clip to follow along with a metronome for the tempo.

𝐍𝐨𝐭𝐞: 𝐘𝐨𝐮 𝐦𝐮𝐬𝐭 𝐩𝐞𝐫𝐟𝐨𝐫𝐦 𝐭𝐡𝐞 𝐬𝐚𝐦𝐞 𝐥𝐞𝐯𝐞𝐥 𝐨𝐧 𝐛𝐨𝐭𝐡 𝐬𝐢𝐝𝐞𝐬!`,
    hasLevel: true,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: false,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'CE.twrG4SAu50ZyZPdQs.g',
    phase: 4,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: 'mlolqGLjSDKajqhL8wT4fA',
    phase: 4,
    exercise: 'Rotational Hop',
    displayName: 'Rotational Hop',
    video: 'https://youtu.be/g0zWC-mml98',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 3,
    metronome: false,
    scoringKey: 'rotationalHop',
  },
  {
    id: 'bPd3eSugQeKno6AJkRJjaQ',
    phase: 4,
    exercise: 'Triple Medial Hop',
    displayName: 'Triple Medial Hop',
    video: 'https://youtu.be/EBnB6TMy8No',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 4,
    metronome: false,
    scoringKey: 'tripleMedialHop',
  },
  {
    id: 'Ctq-9ZvBSAqRetIKad1QfA',
    phase: 4,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/4pJabai7ees',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: false,
    sequence: 5,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true,
  },
  // Machine
  {
    id: 'Nq.ZrjliS7qLgTpRsEZGeg',
    phase: 4,
    exercise: 'Machine Leg Extension',
    displayName: 'Quad Test',
    video: 'https://youtu.be/X6dG2K2tTFM',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 0,
    metronome: true,
    scoringKey: 'quad',
  },
  {
    id: '8RoEkp5hRtOJQrxV02EsHQ',
    phase: 4,
    exercise: 'Machine Leg Curl',
    displayName: 'Hamstring Test',
    video: 'https://youtu.be/GnKPGRg430A',
    description: `The goal of this test is to do at least 5 but no more than 10 reps using a 2-1-2-1 tempo. Choose your weight accordingly.

Begin with your uninjured leg. If you're able to get to 10 reps without reaching failure, repeat with a heavier weight.

Always remember to use full range of motion and avoid jerking with your hips.

Next, test your injured leg. Instead of defaulting to the same weight, 𝐟𝐢𝐧𝐝 𝐭𝐡𝐞 𝐡𝐞𝐚𝐯𝐢𝐞𝐬𝐭 𝐰𝐞𝐢𝐠𝐡𝐭 𝐲𝐨𝐮 𝐜𝐚𝐧 𝐝𝐨 𝙩𝙝𝙚 𝙨𝙖𝙢𝙚 𝙣𝙪𝙢𝙗𝙚𝙧 𝙤𝙛 𝙧𝙚𝙥𝙨 𝐲𝐨𝐮 𝐝𝐢𝐝 𝐨𝐧 𝐭𝐡𝐞 𝐮𝐧𝐢𝐧𝐣𝐮𝐫𝐞𝐝 𝐥𝐞𝐠.

For example, this would be correct: 8 reps with 65 lbs on the uninjured leg and 8 reps with 55 lbs on the injured leg. This would be incorrect: 8 reps with 65 lbs on the uninjured leg and 3 reps with 65 lbs on the injured leg.

Click play on the audio clip to follow along with a metronome for the tempo.`,
    hasLevel: false,
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasDistance: false,
    hasWeight: true,
    hasNotes: true,
    isMachine: true,
    sequence: 1,
    metronome: true,
    scoringKey: 'hamstring',
  },
  {
    id: 'mDh0EE5TRKa9FEWz--WnAw',
    phase: 4,
    exercise: 'Single-Leg Hop',
    displayName: 'Single-Leg Hop',
    video: 'https://youtu.be/x7jwevLjDKg',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 2,
    metronome: false,
    scoringKey: 'singleLegHop',
  },
  {
    id: '9Q0jZpPIRi6FxnowwrUyog',
    phase: 4,
    exercise: 'Rotational Hop',
    displayName: 'Rotational Hop',
    video: 'https://youtu.be/g0zWC-mml98',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 3,
    metronome: false,
    scoringKey: 'rotationalHop',
  },
  {
    id: 'uIwXDr-XT7m7ybHOsS0i.A',
    phase: 4,
    exercise: 'Triple Medial Hop',
    displayName: 'Triple Medial Hop',
    video: 'https://youtu.be/EBnB6TMy8No',
    description: 'Do 2 warm-up hops on each leg, followed by 3 test hops on each leg. Alternate between legs. Document only the best hop on each leg.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: false,
    hasDistance: true,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 4,
    metronome: false,
    scoringKey: 'tripleMedialHop',
  },
  {
    id: 'j8ToLFvqSpCelvGLGvs9gQ',
    phase: 4,
    exercise: 'Side plank',
    displayName: 'Side Plank',
    video: 'https://youtu.be/4pJabai7ees',
    description: 'Do one maximum duration hold on each side, up to 30 seconds.',
    hasLevel: false,
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasDistance: false,
    hasWeight: false,
    hasNotes: true,
    isMachine: true,
    sequence: 5,
    metronome: false,
    scoringKey: 'sidePlank',
    isSidePlank: true,
  },
];

// Helper to get exercises for a phase and machine preference
export function getTestOutExercises(phaseNum, useMachine = false) {
  return testOutExercises
    .filter(ex => ex.phase === phaseNum && ex.isMachine === useMachine)
    .sort((a, b) => a.sequence - b.sequence);
}

// Get exercise by ID
export function getTestOutExerciseById(id) {
  return testOutExercises.find(ex => ex.id === id);
}